var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-border"},[_c('thead',[_c('tr',_vm._l((_vm.thead),function(t){return _c('th',[_vm._v(_vm._s(t))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tbody),function(t){return _c('tr',[_c('td',[_vm._v(_vm._s(t))])])}),0),_vm._v(" "),_c('tfoot')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185b4eb6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Yazdir/TableYazdir.vue
// module id = 1140
// module chunks = 0